module.exports = {"350629100":"华丰镇","350629101":"丰山镇","350629102":"沙建镇","350629103":"新圩镇","350629104":"高安镇","350629105":"仙都镇","350629200":"高车乡","350629201":"马坑乡","350629203":"湖林乡","350629400":"福建土楼（华安）旅游区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350629.json
// module id = 1330
// module chunks = 0